import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout';
import EventView from './views/eventView';
import Page404 from './views/page404';
import EventDetailView from './views/eventDetailView';
import TicketsDetailView from './views/ticketsDetailView';
import PaymentView from './views/paymentView';
import PaymentDebugView from './views/paymentDebugView';
import ThanksView from './views/thanksView';
import LoginView from './views/loginView';
import SignupGroupView from './views/signupGroupView';
import ScrollToTop from './tools/ScrollToTop';
import ThanksGroupView from './views/thanksGroupView';
import LoginAdminView from './views/admin/loginAdminView';
import DashboardView from './views/admin/dashboardView';
import { RoutesWeb } from './tools/RoutesWeb';
import AddLeaderView from './views/admin/addLeaderView';
import EditEventView from './views/admin/editEventView';
import LeadersView from './views/admin/leadersView';
import ScanTicketView from './views/admin/scanTicketView';
import DecanatoLoadsView from './views/admin/decanatoLoadsView';
import ResendTicketsView from './views/resendTicketsView';
require('./style/main.scss');

function App() {
return (
	<Router>
		<Layout>
			<ScrollToTop />
			<Routes>
				<Route exact path={RoutesWeb.HOME} element={<EventView />} />
				<Route exact path={RoutesWeb.DETAILS} element={<EventDetailView />} />
				<Route exact path={RoutesWeb.DETAILS_TICKET} element={<TicketsDetailView />} />
				<Route exact path={RoutesWeb.PAYMENT} element={<PaymentView />} />
				<Route exact path={RoutesWeb.PAYMENT_DEBUG} element={<PaymentDebugView />} />
				<Route exact path={RoutesWeb.RESEND_TICKETS} element={<ResendTicketsView />} />
				<Route exact path='/gracias/:obj' element={<ThanksView />} />

				<Route exact path={RoutesWeb.LOGIN_GROUP} element={<LoginView />} />
				<Route exact path={RoutesWeb.REGISTER_GROUP} element={<SignupGroupView />} />
				<Route exact path={RoutesWeb.REGISTER_GROUP_THANKS} element={<ThanksGroupView />} />
				<Route exact path={RoutesWeb.EDIT_EVENT} element={<EditEventView />} />

				<Route exact path={RoutesWeb.ADMIN_LOGIN} element={<LoginAdminView />} />
				<Route exact path={RoutesWeb.ADMIN_DASHBOARD} element={<DashboardView />} />
				<Route exact path={RoutesWeb.ADMIN_ADD_LEADER} element={<AddLeaderView />} />
				<Route exact path={RoutesWeb.ADMIN_LEADERS} element={<LeadersView />} />
				<Route exact path={RoutesWeb.ADMIN_SCAN_TICKETS} element={<ScanTicketView />} />
				<Route exact path={RoutesWeb.ADMIN_DECANATO_LOADS} element={<DecanatoLoadsView />} />
				<Route path="/*" element={<Page404 />} />
			</Routes>
		</Layout>
	</Router>
);
}

export default App;
